import { Email } from "../models/Email";
import { callPost } from "./index";

export class SendEmail {
  static async send(userId:number,email: Email): Promise<void> {
    await callPost(`users/${userId}/email-support`, email.toJSON());
  }
}
